import _defineProperty from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { genBorderlessStyle, genFilledStyle, genOutlinedStyle } from '../../input/style/variants';
var genVariantsStyle = function genVariantsStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, componentCls, [Object.assign(Object.assign(Object.assign({}, genOutlinedStyle(token)), genFilledStyle(token)), genBorderlessStyle(token)),
  // ========================= Multiple =========================
  {
    '&-outlined': _defineProperty({}, "&".concat(componentCls, "-multiple ").concat(componentCls, "-selection-item"), {
      background: token.multipleItemBg,
      border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.multipleItemBorderColor)
    }),
    '&-filled': _defineProperty({}, "&".concat(componentCls, "-multiple ").concat(componentCls, "-selection-item"), {
      background: token.colorBgContainer,
      border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorSplit)
    }),
    '&-borderless': _defineProperty({}, "&".concat(componentCls, "-multiple ").concat(componentCls, "-selection-item"), {
      background: token.multipleItemBg,
      border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.multipleItemBorderColor)
    })
  }]);
};
export default genVariantsStyle;